import { gsap } from 'gsap';

export default function() {
  $('body').append($(`
    <div id="backdrop"></div>
    <style>
        #backdrop {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            opacity: 0;
            visibility: hidden;
            background-color: rgba(0,0,0, 0.3);
            transition: opacity .1s, visibility .1s;
            z-index: 11;
        }
    </style>
  `));

  $('#backdrop').on('click', function(){
    const $openCountrySwitcher = $('.lang-switcher__modal.open');
    if ($openCountrySwitcher.length) {
      $openCountrySwitcher.removeClass('open');
    }

    const $openLangSwitcher = $('.country-switcher__modal.open');
    if ($openLangSwitcher.length) {
      $openLangSwitcher.removeClass('open');
    }

    const $openMiniCart = $('.minicart__drawer.minicart__drawer--open');
    if ($openMiniCart.length) {
      $openMiniCart.removeClass('minicart__drawer--open');
      document.querySelector('html').classList.remove('minicart-open');
    }

    hideBackdrop();
  });
}

const showBackdrop = function() {
  gsap.to('#backdrop', {autoAlpha: 1, duration: .1});
}

const hideBackdrop = function() {
  gsap.to('#backdrop', {autoAlpha: 0, duration: .1});
}

export {
  showBackdrop,
  hideBackdrop
}
